import { render, staticRenderFns } from "./ntdetails.vue?vue&type=template&id=6cb5f993&scoped=true"
import script from "./ntdetails.vue?vue&type=script&lang=js"
export * from "./ntdetails.vue?vue&type=script&lang=js"
import style0 from "./ntdetails.vue?vue&type=style&index=0&id=6cb5f993&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5f993",
  null
  
)

export default component.exports